import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'falsy',
  standalone: true
})
export class FalsyPipe implements PipeTransform {
  transform(value: any): boolean {
    if (value && typeof value === 'object' && value.length !== undefined) {
      return value.length === 0;
    }
    return !value;
  }
}
